import {
  OPERATORS,
  SCOPE_RESTRICTION_TYPE,
  ZIP_CODE_RANGE_OPERATOR,
  type ItemRestriction,
  type Scope,
  type ZipCodeRange,
} from 'typings'
import {
  BrandSelector,
  CategorySelector,
  ProductSelector,
  SkuSelector,
} from '../Selectors'

export const SCOPE_OPERATORS: Record<
  SCOPE_RESTRICTION_TYPE,
  { equals: string; different: string }
> = {
  skus: {
    equals: 'admin/promotions.form.scope.skus.operator.equals',
    different: 'admin/promotions.form.scope.skus.operator.different',
  },
  products: {
    equals: 'admin/promotions.form.scope.products.operator.equals',
    different: 'admin/promotions.form.scope.products.operator.different',
  },
  brands: {
    equals: 'admin/promotions.form.scope.brands.operator.equals',
    different: 'admin/promotions.form.scope.brands.operator.different',
  },
  categories: {
    equals: 'admin/promotions.form.scope.categories.operator.equals',
    different: 'admin/promotions.form.scope.categories.operator.different',
  },
}

export const SCOPE_SELECTORS: Record<SCOPE_RESTRICTION_TYPE, JSX.Element> = {
  skus: <SkuSelector.Selector name="scope.skus.items" />,
  products: <ProductSelector name="scope.products.items" />,
  brands: <BrandSelector name="scope.brands.items" />,
  categories: <CategorySelector name="scope.categories.items" />,
}

export const SCOPE_RESTRICTION_TYPES: Array<{
  id: SCOPE_RESTRICTION_TYPE
  labelId: string
}> = [
  {
    id: SCOPE_RESTRICTION_TYPE.CATEGORIES,
    labelId: 'admin/promotions.form.scope.categories.label',
  },
  {
    id: SCOPE_RESTRICTION_TYPE.BRANDS,
    labelId: 'admin/promotions.form.scope.brands.label',
  },
  {
    id: SCOPE_RESTRICTION_TYPE.PRODUCTS,
    labelId: 'admin/promotions.form.scope.products.label',
  },
  {
    id: SCOPE_RESTRICTION_TYPE.SKUS,
    labelId: 'admin/promotions.form.scope.skus.label',
  },
]

export const DEFAULT_INITIAL_EDITORS: Set<SCOPE_RESTRICTION_TYPE> = new Set([
  SCOPE_RESTRICTION_TYPE.PRODUCTS,
])

export const EMPTY_SCOPE_RESTRICTION: ItemRestriction = Object.freeze({
  items: [],
  operator: OPERATORS.EQUALS,
})

export const EMPTY_SCOPE: Scope = Object.freeze({
  skus: { ...EMPTY_SCOPE_RESTRICTION },
  products: { ...EMPTY_SCOPE_RESTRICTION },
  categories: { ...EMPTY_SCOPE_RESTRICTION },
  brands: { ...EMPTY_SCOPE_RESTRICTION },
})

export const EMPTY_ZIP_CODE_RANGE: ZipCodeRange = {
  from: '',
  to: '',
  operator: ZIP_CODE_RANGE_OPERATOR.INCLUDE,
}
